import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/arrow-right.svg";
var ArrowRightSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ArrowRightSolid_default as default
};
